module.exports = __webpack_public_path__ + "img/daichao1.e307b476.png";